import { Component, OnInit, Input } from '@angular/core';
import { NodoEntity, ServicioFormatoAsistencialService, EstructuraNodo, TipoObjeto,
  DatoEntity, FiltrosFormatoAsistencialEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { NodoService } from 'src/app/services/utils/nodo.service';

@Component({
  selector: 'app-matriz-agrupamiento',
  templateUrl: './matriz-agrupamiento.component.html',
  styleUrls: ['./matriz-agrupamiento.component.css']
})
export class MatrizAgrupamientoComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  html: string;
  htmlBuilder: string;
  ready: boolean;

  constructor(private servicioNodos: NodoService,
              private servicioFormato: ServicioFormatoAsistencialService) { }
  ngOnInit() {
    if (this.nodo) {
      if (this.nodo.datos && this.nodo.datos.length > 0) {
        this.titulo = this.nodo.titulo;
        this.ready = false;
        this.html = this.onMainProcess();
        this.ready = true;
      } else {
        if (this.filtros.diligenciados) {
          this.onDelete();
        } else {
          this.titulo = this.nodo.titulo;
          this.ready = false;
          this.html = this.onMainProcess();
          this.ready = true;
        }
      }
    } else {
      this.titulo = '';
    }
  }

  onMainProcess(): string {
    this.htmlBuilder = '';
    const counter = 1;
    const map = this.servicioNodos.groupNodosByType(this.nodo.hijos);
    const maprc = {};
    this.htmlBuilder += `<table class="table-report">`;
    if (map && map[EstructuraNodo.Pregunta]) {
      // Hace falta desarrollar para esta sección;
    }

    if (map && map[EstructuraNodo.Grupo]) {
      let nodos: NodoEntity[] = map[EstructuraNodo.Grupo];
      nodos = nodos.sort((a: NodoEntity, b: NodoEntity) => a.orden - b.orden);
      nodos.forEach((group: NodoEntity) => {
        group.hijos = this.servicioFormato.getNodosHijos(group);
        const agrupacion = this.generateGroupAgrupacion(group, group.hijos, map[EstructuraNodo.Respuesta],
          map[EstructuraNodo.Encabezado], counter);
        Object.assign(maprc, agrupacion);
      });
    }
    this.htmlBuilder += '</table>';
    // Hace falta desarrollar sección de totales.
    return this.htmlBuilder;
  }

  generateGroupAgrupacion(grupo: NodoEntity, preguntas: NodoEntity[],
    columnas: NodoEntity[], tipos: NodoEntity[], contador: number): { id ?: number, ids ?: number[]} {
      if (preguntas && preguntas.length > 0) {
        const rcache: { id ?: number, ids ?: number[]} = {};
        const titulo = grupo.titulo;
        this.htmlBuilder += `<tr><th class="table-cell table-header-cell table-cell-padding text-center">${titulo}</th>`;
        this.getColumnsForGroup(tipos, true, true, false);
        this.getColumnsForGroup(columnas, true, true, false);
        this.htmlBuilder += `</tr>`;
        if (preguntas && preguntas.length > 0) {
          preguntas.forEach((p: NodoEntity) => {
            this.htmlBuilder += '<tr>';
            let ttlo = p.titulo;
            if (ttlo === '|#|') {
              ttlo = ttlo.replace('|#|', `${contador}.`);
            } else {
              ttlo = ttlo.replace('|#|', `${contador}`);
            }

            this.htmlBuilder += `<td class="table-cell table-cell-padding">${ttlo}</td>`;
            rcache[p.id] = this.generatedTypesfor(p, tipos);

            if (columnas) {
              columnas.forEach((c: NodoEntity) => {
                const configCol = this.matrizAgrupacionMenuParseValue(c);
                const tmp: NodoEntity[] = [];
                tmp.push(c);

                switch (c.codigoTipoObjeto) {
                  case TipoObjeto.ListaDesplegable:
                  case TipoObjeto.SeleccionUnica: {
                    const case_: string = configCol['value'] ? configCol['value'] : '';
                    if (!case_ || case_.length === 0 || case_ === '0') {
                      this.generateControl(p, tmp, false);
                    } else {

                    }
                  } break;

                  default : {
                    this.generateControl(p, tmp, false);
                  } break;
                }
              });
            }

            this.htmlBuilder += '</tr>';
            contador++;
          });
        }
        return rcache;
      }
    return null;
  }

  getColumnsForGroup(nodos: NodoEntity[], showTitle: boolean, showTitleItems: boolean, first: boolean): Number {
    let count = 0;
    if (nodos && nodos.length > 0) {
      nodos.forEach((n: NodoEntity) => {
        if (n.codigoTipoObjeto === TipoObjeto.SeleccionUnica) {
          if (showTitleItems && n.hijos && n.hijos.length > 0) {
            n.hijos.forEach((h: NodoEntity) => {
              this.getHeaderColumn(h, true, 1, 1);
              count++;
            });
          }
        } else {
          if (!first) {
            this.htmlBuilder += `<th class="table-cell table-header-cell table-cell-padding text-center">${showTitle ? n.titulo : '--'}</th>`;
            count++;
          }
        }
      });
    }
    return count;
  }

  getHeaderColumn(col: NodoEntity, orientacion: boolean, rowSpan: number, colSpan: number) {
    this.htmlBuilder += `<th class="table-cell table-header-cell table-cell-padding text-center" rowspan="${rowSpan}" colspan="${colSpan}">`;
    this.htmlBuilder += col.titulo ? col.titulo : '';
    this.htmlBuilder += '</th>';
  }

  generatedTypesfor(p: NodoEntity, types: NodoEntity[]): number[] {
    if (p && types) {
      const map = this.servicioNodos.parseGroupFromValueNodo(p);
      const ct: number[] = [];
      types.forEach((t: NodoEntity) => {
        this.htmlBuilder += `<td class="table-cell">`;
        if (map[t.codigo]) {
          let ts: NodoEntity = null;
          if (t.hijos && t.hijos.length > 0) {
            t.hijos.forEach((tc: NodoEntity) => {
              if (tc.codigo && tc.codigo === map[t.codigo]) {
                ts = tc;
              }
            });

            if (ts) {
              ct.push(ts.id);
              this.htmlBuilder += ts.titulo;
              map[t.codigo] = null;
            }
          }
        } else {
          const parseValue = this.servicioNodos.parseVal(p.valor);
          if (parseValue) {
            const code: string = parseValue[t.codigo];
            if (code && code.length > 0) {
              let ts: NodoEntity = null;
              if (t.hijos && t.hijos.length > 0) {
                t.hijos.forEach((tc: NodoEntity) => {
                  if (tc.codigo && tc.codigo === code) {
                    ts = tc;
                  }
                });

                if (ts) {
                  this.htmlBuilder += ts.descripcion ? ts.descripcion : '';
                }
              }
            }
          }
        }
        this.htmlBuilder += '</td>';
      });
      return ct;
    }
    return null;
  }

  matrizAgrupacionMenuParseValue(nodo: NodoEntity): any {
    if (nodo.codigoEstructura === EstructuraNodo.Pregunta) {
      if ((nodo.valor as any) instanceof String) {
        let value: any = this.servicioNodos.parseVal(nodo.valor);
        if (!value && nodo.valor && nodo.valor.length > 0) {
          value = this.servicioNodos.parseGroupFromValueNodo(nodo);
        }
        return value;
      } else if ((nodo.valor as any) instanceof Object) {
        return (nodo.valor as any);
      }
    } else {
      return this.matrizMenuParseValue(nodo);
    }
    return {};
  }

  matrizMenuParseValue(nodo: NodoEntity) {
    if ((nodo.valor as any) instanceof String) {
      const value = this.servicioNodos.parseVal(nodo.valor);
      if (!value && nodo.valor && nodo.valor.length > 0) {
        value['value'] = nodo.valor;
      }
      return value;
    } else if ((nodo.valor as any) instanceof Object) {
      return (nodo.valor as any);
    }
    return {};

  }

  generateControl(nodo: NodoEntity, columnas: NodoEntity[], showTitle: boolean): void {
    if (nodo && columnas) {
      for (let i = 0; i < columnas.length ; i++) {
        const col = columnas[i];
        switch (col.codigoTipoObjeto) {
          case TipoObjeto.SeleccionUnica : {
            for (let j = 0; j < col.hijos.length ; j++) {
              const item = col.hijos[j];
              const selected: boolean = this.getDataSeleccionUnica(nodo.id, col.id, item.id);
              const el = selected ? `<i class="fa fa-check-circle-o"></i>` : `<i class="fa fa-circle-o"></i>`;
              this.htmlBuilder += `<td class="table-cell text-center">${el}</td>`;
            }
          } break;

          case TipoObjeto.ListaDesplegable : {
            const value = this.getDataListaDesplegable(nodo.id, col.id, col);
            this.htmlBuilder += `<td class="table-cell text-center">${value}</td>`;
          } break;

          case TipoObjeto.CasillaVerificacion : {
            const selected: boolean = this.getDataCasillaVerificacion(nodo.id, col.id);
            const el = selected ? `<i class="fa fa-check-square-o"></i>` : `<i class="fa fa-square-o"></i>`;
            this.htmlBuilder += `<td class="table-cell text-center">${el}</td>`;
          } break;

          default : {
            // Hace falta desarrollar sección de mas tipos de objetos.
            this.htmlBuilder += `<td class="table-cell text-center no-value"></td>`;
          }break;
        }
      }
    }
  }

  getDataSeleccionUnica(nodoRelacionado1: number, nodoRelacionado2: number, value: number): boolean  {
    const dato = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2);
    if (dato)  {
      const valueSelected = Number(dato.valor);
      return valueSelected === value;
    }
    return false;
  }

  getDataCasillaVerificacion(nodoRelacionado1: number, nodoRelacionado2: number) {
    const dato = this.nodo.datos.find((d: DatoEntity) => d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2);
    if (dato)  {
      const valueSelected =  dato.valor != null && dato.valor.toLowerCase().trim() === 'true';
      return valueSelected;
    }
    return false;
  }

  getDataListaDesplegable(nodoRelacionado1: number, nodoRelacionado2: number, columna: NodoEntity): string {
    if (this.nodo.datos) {
      const dato: DatoEntity = this.nodo.datos.find((d: DatoEntity) => {
        return d.idNodoRelacionado1 === nodoRelacionado1 && d.idNodoRelacionado2 === nodoRelacionado2;
      });

      if (dato) {
        try {
          const id: number = Number(dato.valor);
          if (id && columna.hijos && columna.hijos.length > 0) {
            const value: NodoEntity = columna.hijos.find((c: NodoEntity) => c.id === id);
            if (value) { return value.titulo; }
          }
        } catch (e) {
          console.error('Value ListaDesplegable.Matriz is not number?', e);
        }
      }
    }
    return 'no seleccionado';
  }

  onDelete() { }

}
